import { createContext, useContext } from 'react';
import { Format } from 'common/types/format';
import { Row } from 'common/types/scalarSpreadsheet';
import { ReverseParsedFundOwnershipDetail } from 'pages/CapTable/fund-ownership/types';
import { Cell } from '../../ScalarSpreadsheet/utilities/Cell';
import SharedSpreadsheetProps from '../models/SharedSpreadsheet.props';

interface CellCoordinates {
  j: number
  i: number
}

export interface SelectedCellInfo {
  start: CellCoordinates;
  end: CellCoordinates;
  rowNumber: number;
  cellInfo: Cell;
  // Present when the selection spans multiple cells; used by RowIndicator to
  // locate the end-of-selection DOM element for multi-row indicator positioning
  endCellInfo?: Cell;
}

export interface FeaturedSpreadsheetContextType extends SharedSpreadsheetProps {
  activeCell: Cell;
  displayLegend: true;
  getClassnamesForLegends: (...args: any[]) => void;
  handleDeleteColumn: (...args: any[]) => void;
  onCellsChanged: (...args: any[]) => Promise<void>;
  rows: Row[];
  selectedCell: SelectedCellInfo;
  setActiveCell: (...args: any[]) => void;
  setClearSelected: (...args: any[]) => void;
  setSelectedCell: (...args: any[]) => void;
  titlesColumnRef: any; // no type found
  totalsColumnRef: any; // no type found
  clearSelectedFlag: boolean;
  currency: string;
  setCurrency: (value: string) => void;
  format: Format;
  columns: ReverseParsedFundOwnershipDetail[];
  allowChangeDataType?: boolean;
  changeRowDataTypeFn?: (cell: any, newValue: any) => void;
  isToolbarVisible?: boolean;
  displayDeleteRowBtn?: boolean;
  allowReorderRows?: boolean;
  allowSortColumn?: boolean;
  allowDeleteOnlySpecificColumn?: boolean;
  sortColumnFn?:  (columnKey: string, fieldIsString: boolean, fieldIsDate: boolean) => void;
  sortedColumn?: Record<string, any>;
  workbook?: Record<string, any>;
  /** True while column reorder drag is active; selection should not change. */
  isColumnDragging?: boolean;
}
const FeaturedSpreadsheetContext = createContext<FeaturedSpreadsheetContextType>({} as FeaturedSpreadsheetContextType);

const useFeatureSpreadsheet = () => useContext(FeaturedSpreadsheetContext);

export default FeaturedSpreadsheetContext;

export { useFeatureSpreadsheet };
